import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { captureEvent } from '../../../../services/event-capture';
import { useAppDispatch } from '../../../../services/store';
import {
  followMember,
  getAllFollowsForCurrentMemberWithSignal,
} from '../../../../services/store/modules/follows';
import { getSharedSignalsByCurrentMember } from '../../../../services/store/modules/signal';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import UserLookup, { UserSearchResult } from '../components/UserLookup';

const FindFriendsToFollowPage: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const allFollowed = useSelector(getAllFollowsForCurrentMemberWithSignal);

  useEffect(() => {
    dispatch(getSharedSignalsByCurrentMember());
  }, [dispatch]);

  const filterUserLookup = (
    matches: UserSearchResult[],
    currentMemberId: string | undefined,
  ) =>
    matches
      .filter((match) => match.id !== currentMemberId)
      .filter(
        (match) =>
          !allFollowed.find((follow) => follow.followee.id === match.id),
      );

  const handleBack = async () => {
    await captureEvent({
      type: 'signal: back to activate signal',
      payload: {},
      sendToAmplitude: true,
    });

    history.goBack();
  };

  const handleSelectUser = async (memberId: string) => {
    await captureEvent({
      type: 'signal: follow user',
      payload: {
        memberId,
      },
      sendToAmplitude: true,
    });

    await dispatch(followMember(memberId)).unwrap();

    // Redirect back to signal share list page
    history.push('/maps/signal/friends-sheet');
  };

  return (
    <BasicDrawerLayout onBack={handleBack} heading="Search" showMenuBar={false}>
      <UserLookup
        onSelectUser={handleSelectUser}
        filterSearchResults={filterUserLookup}
      />
    </BasicDrawerLayout>
  );
};

export default FindFriendsToFollowPage;
